module.exports = __webpack_public_path__ + "static/media/l12_voice_three_v2.b8e3b821.mp3";